import React from 'react';
import { AnimatePresence } from 'framer-motion';
import { FiX, FiUser, FiMail, FiCheck } from 'react-icons/fi';
import useForgotUsernameModal from './useForgotUsernameModal';
import { maskEmail } from './forgotUsernameModalHelpers';
import {
  ModalOverlay, ModalContent, CloseButton, ModalTitle, ModalSubtitle, Form, FormGroup,
  InputWrapper, Input, Icon, Button, LoadingSpinner, ErrorMessage, SuccessMessage,
  EmailDisplay, EmailText, BackToLogin
} from './ForgotUsernameModal.styles';

function ForgotUsernameModal({ isOpen, onClose }) {
  const {
    formData, loading, error, success, foundEmail, handleChange, handleSubmit, handleClose,
    handleBackToLogin
  } = useForgotUsernameModal({ onClose });

  return (
    <AnimatePresence>
      {isOpen && (
        <ModalOverlay
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={handleClose}
        >
          <ModalContent
            initial={{ opacity: 0, scale: 0.9, y: 20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.9, y: 20 }}
            onClick={(e) => e.stopPropagation()}
          >
            <CloseButton onClick={handleClose} aria-label="Close modal">
              <FiX size={20} />
            </CloseButton>

            <ModalTitle>Forgot Username?</ModalTitle>
            <ModalSubtitle>
              Enter your first and last name to retrieve your email address.
            </ModalSubtitle>

            {!success ? (
              <Form onSubmit={handleSubmit}>
                <FormGroup>
                  <InputWrapper>
                    <Icon>
                      <FiUser size={16} />
                    </Icon>
                    <Input
                      type="text"
                      name="firstName"
                      placeholder="First Name"
                      value={formData.firstName}
                      onChange={handleChange}
                      required
                    />
                  </InputWrapper>
                </FormGroup>

                <FormGroup>
                  <InputWrapper>
                    <Icon>
                      <FiUser size={16} />
                    </Icon>
                    <Input
                      type="text"
                      name="lastName"
                      placeholder="Last Name"
                      value={formData.lastName}
                      onChange={handleChange}
                      required
                    />
                  </InputWrapper>
                </FormGroup>

                {error && (
                  <ErrorMessage
                    initial={{ opacity: 0, height: 0 }}
                    animate={{ opacity: 1, height: 'auto' }}
                    exit={{ opacity: 0, height: 0 }}
                    role="alert"
                  >
                    {error}
                  </ErrorMessage>
                )}

                <Button type="submit" disabled={loading}>
                  {loading ? (
                    <>
                      <LoadingSpinner />
                      Searching...
                    </>
                  ) : (
                    <>
                      <FiMail size={16} />
                      Find My Email
                    </>
                  )}
                </Button>
              </Form>
            ) : (
              <div>
                <SuccessMessage
                  initial={{ opacity: 0, height: 0 }}
                  animate={{ opacity: 1, height: 'auto' }}
                  role="alert"
                >
                  <FiCheck size={20} style={{ marginBottom: '0.5rem' }} />
                  <div>Account found!</div>
                </SuccessMessage>

                <EmailDisplay>
                  <EmailText>{maskEmail(foundEmail)}</EmailText>
                </EmailDisplay>

                <BackToLogin onClick={handleBackToLogin}>
                  Back to Login
                </BackToLogin>
              </div>
            )}
          </ModalContent>
        </ModalOverlay>
      )}
    </AnimatePresence>
  );
}

export default ForgotUsernameModal;
